import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { CostLayout } from "../CostLayout";
import { CostRouterProps } from "../CostRouterProps";

interface HomePageProps extends NSARouterMakerResult, CostRouterProps { }

export default function HomePage(props: HomePageProps)
{
    return (
        <CostLayout
            {...props}
        >
            <NSAHomePage
                {...props}
            />
        </CostLayout>
    );
}